import React from "react";
import Button from "@/ui/Button/Button";
import { useAdminPriceEdaContext } from "./context";
import { getEditorModeLabel } from "./helpers";
import cls from "./styles.module.scss";

export const EditorModeSwitch = () => {
  const {
    interaction: { editorMode, setEditorMode },
  } = useAdminPriceEdaContext();

  return (
    <div className={cls.sidebarSection}>
      <div className={cls.sidebarLabel}>Инструмент</div>
      <div className={cls.modeSwitch}>
        <Button
          type="button"
          label="Клик"
          variant="outlined"
          onClick={() => setEditorMode("click")}
          className={
            editorMode === "click" ? cls.modeButtonActive : cls.modeButton
          }
        />
        <Button
          type="button"
          label="Лассо"
          variant="outlined"
          onClick={() => setEditorMode("lasso")}
          className={
            editorMode === "lasso" ? cls.modeButtonActive : cls.modeButton
          }
        />
      </div>
      <div className={cls.sidebarValue}>
        {`Текущий режим: ${getEditorModeLabel(editorMode)}`}
      </div>
    </div>
  );
};
